module.exports = __webpack_public_path__ + "img/hyu_detail.51922d6e.jpg";